import { useQuery } from '@tanstack/react-query';
import { qrApi } from '~/lib/request';
import { QrCode } from './types';

function useGenerateQrCode() {
  const result = useQuery({
    queryKey: ['qrCodeGenerator'],
    queryFn: () => qrApi.get('api/qr_code/generate').json<QrCode>(),
  });

  return result;
}

export default useGenerateQrCode;
